import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import Require from "~common/components/require"
import BulletinEditView from "~bulletins/components/bulletin-edit-view-new"
import BulletinListView from "~bulletins/components/bulletin-list-view"
import BulletinQueryList from "~bulletins/components/bulletins-query-list-view"
import {Typography} from '@mui/material'




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  status: "loading" | "ready"
}

class BulletinAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {status: "ready"}
  }

  render() {

    const {match} = this.props;
    const { classes, history}: {classes: ClassNameMap; history: any} = this.props
    const { status} = this.state
    var selectedBulletinID
    if(match && match.params && match.params.id) {
      selectedBulletinID = match.params.id
    }

    var view 
    if (status === "loading") {
      view = <LoadingView />
    } else if (selectedBulletinID) {
      view = <BulletinEditView match={match} bulletinId={selectedBulletinID} history={history} classes={{}} />
    } else {
      view = <BulletinQueryList></BulletinQueryList> 
    }

    return (
      <AppView>
        <Require requireOneOfFeatures={["bulletin_admin"]}>
            <Typography id="bulletinAdminTitle" variant="h5" className={classes.heading}>
               Bulletin Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(BulletinAdmin)
